import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import DebtReliefAnalysisWrapper from "@components/layouts/debtReliefAnalysisWrapper";
import { useDomainContext } from "@hooks/useDomainContext";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function DebtReliefAnalysisHome(): ReactElement {
    const { domain } = useDomainContext();
    return (
        <DebtReliefAnalysisWrapper>
            <PrivacyPolicy
                category={domain?.categories[0]?.name}
                domain={domain.niceName}
            />
        </DebtReliefAnalysisWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
